import { render, staticRenderFns } from "./Approvement.vue?vue&type=template&id=03a98834&"
import script from "./Approvement.vue?vue&type=script&lang=js&"
export * from "./Approvement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports